<template>
  <div>
    <div class="inset-0 fixed z-50">
      <div class="loading bg-black opacity-50">
        <span class="circle"></span>
      </div>
    </div>
  </div>
</template>
